// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"useHoverTooltip_tooltip__lyr9L","fadeIn":"useHoverTooltip_fadeIn__IlOb8"};